module.exports = __webpack_public_path__ + "static/media/wgs3.png.194a613e.jpg";